/**
 * Recalculo dos quatro tokens de acento a partir do matiz escolhido.
 *
 * A marca varia pelos tokens e pelo tema, sem aceitar cores literais do usuario.
 */
export function tokensDaMarca(
matiz: number,
tema: 'escuro' | 'claro'): Record<string, string> {
  const h = Math.max(0, Math.min(360, Math.round(matiz)));
  const componentes = {
    '--cor-acento': [0.5, 0.2, h],
    '--cor-acento-forte': [tema === 'claro' ? 0.44 : 0.58, 0.21, h],
    '--cor-acento-tenue': [0.5, 0.2, h, tema === 'claro' ? 0.1 : 0.14],
    '--cor-acento-tinta': [tema === 'claro' ? 0.99 : 0.97, tema === 'claro' ? 0.01 : 0.02, h]
  };
  return Object.fromEntries(
    Object.entries(componentes).map(
      ([k, v]) => [k, `oklch(${v.slice(0, 3).join(' ')}${v[3] !== undefined ? ` / ${v[3]}` : ''})`]
    )
  );
}
